import { render, staticRenderFns } from "./ProgramTabFees.vue?vue&type=template&id=ea95cee8&"
import script from "./ProgramTabFees.vue?vue&type=script&lang=js&"
export * from "./ProgramTabFees.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTabFees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports